import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { BsFillInfoCircleFill } from "react-icons/bs";

import * as S from "./tool-tip.styles";

export const ToolTipWrapper = (props) => (
  <>
    <OverlayTrigger
      key={props.position}
      placement={props.position}
      overlay={<Popover id={props.position}>{props.content}</Popover>}
    >
      <S.InfoIcon>
        <BsFillInfoCircleFill />
      </S.InfoIcon>
    </OverlayTrigger>
  </>
);
